export const siteInfo = {
  name: '前列腺健康知识科普',
  tagline: '科学、专业、负责任的男性健康指导平台',
  description: '我们是一个致力于男性前列腺健康知识科普的专业平台。以循证医学为基础，提供前列腺高潮原理、刺激技巧、健康益处与安全须知的全方位科学指导。我们的使命是帮助成年男性全面、科学地了解自身身体，消除误解与顾虑，促进身心健康。',
  founded: '2024年',
  team: [
    {
      name: '医学顾问团队',
      role: '泌尿外科、男科、性医学科专家组成的顾问委员会',
      description: '所有发布内容均经过执业医师审核，确保信息的科学性、准确性和时效性。',
    },
    {
      name: '科普编辑团队',
      role: '医学传播专业人员',
      description: '将专业医学知识转化为公众易于理解的科普语言，确保内容的可读性和实用性。',
    },
  ],
  values: [
    {
      title: '科学为本',
      description: '所有内容基于同行评议的科学研究，绝不传播未经证实的观点或偏方。',
      icon: 'ri-microscope-line',
    },
    {
      title: '专业负责',
      description: '由执业医师审核内容，确保医学信息的准确性和安全性。',
      icon: 'ri-shield-star-line',
    },
    {
      title: '隐私至上',
      description: '我们充分尊重每一位读者的隐私，不收集个人身份信息。',
      icon: 'ri-lock-line',
    },
    {
      title: '开放包容',
      description: '以非评判的态度提供信息，尊重每一位成年人的自主选择权利。',
      icon: 'ri-heart-line',
    },
  ],
  contact: {
    email: 'contact@prostate-health-guide.readdy.ai',
    wechat: 'ProstateHealthGuide',
    address: '在线服务平台，不设实体办公地址',
    workingHours: '在线服务，7×24小时',
  },
  socialProof: [
    { label: '累计读者', value: '50万+' },
    { label: '科普文章', value: '200+' },
    { label: '专家审核', value: '100%' },
    { label: '读者好评', value: '98%' },
  ],
};